// Loads select2 and its CSS. This allows the CSS to be bundled with the JS
// for a single dynamic inclusion at runtime.
// select2 3.5 is used by Alchemy, so all select2 4.0 has -4 added after select2.
define(['select2-4', 'select2-css-bundle.less'], (select2) => select2)
